import { Component, Input, OnInit } from '@angular/core';
import { IBlog, IDashboardMidwifePayload } from 'src/app/models/dashboard.models';

@Component({
  selector: 'app-my-recent-blogs',
  templateUrl: './my-recent-blogs.component.html',
  styleUrls: ['./my-recent-blogs.component.scss']
})
export class MyRecentBlogsComponent implements OnInit {

  @Input() midwife: IDashboardMidwifePayload;
  blogs: Array<IBlog> = [];
  constructor() { }

  ngOnInit(): void {
    if( this.midwife.blogs)
    {
      this.blogs = this.midwife.blogs.reverse().slice(0,3);
    }
  }

}
